import React, { Fragment, useState } from "react";

import CustomDropDown from "../CustomDropDown/CustomDropDown";
import classes from "./Footer.module.css";
import downArrowWhite from "../../../assets/svg/downArrowWhite.svg";
import Facebook from "../../../assets/svg/Facebook.svg";
import YouTube from "../../../assets/svg/YouTube.svg";
import Twiter from "../../../assets/svg/Tiwiter.svg";
import Instagarm from "../../../assets/svg/Instagarm.svg";

const Footer = (porps) => {
    const [showDrop, setShowDrop] = useState(false);
    const [headerValue, setheaderValue] = useState('');
    const headerclickHandler = (event) => {
        setheaderValue(event.target.className);
        setShowDrop(true);
    }
    return (
        <Fragment>
            <div className={classes.Footer} >
                <div className={`${classes.Col} ${classes.AlignRight}`}>
                    <h1>How We Help</h1>
                    <p>User  Service  Distributer</p>
                    <p>Dealer</p>
                    <p>Wholesalers / Importers</p>
                    <p>Distributer</p>
                </div>
                <div className={classes.Col}>
                    <h1>Get to Know Us</h1>
                    <p>About</p>
                    <p>Policies</p>
                    <p>Careers</p>
                    <p>Press</p>
                </div>
                <div className={classes.Col}>
                    <h1>Join the Community</h1>
                    <p>Upcoming Events</p>
                    <p>Become a Buyer</p>
                    <p>Become a Dealer</p>
                </div>
                <div className={`${classes.Col} ${classes.AlignRight}`}>
                    <h1>Follow Us</h1>
                    <p><img src={Facebook} alt='' />Facebook</p>
                    <p><img src={YouTube} alt='' />YouTube</p>
                    <p><img src={Twiter} alt='' />Twitter</p>
                    <p><img src={Instagarm} alt='' />Instagram</p>
                </div>
            </div>
            <div  className={classes.onlysmallScreen}>
                {
                    showDrop && headerValue === 'help' ?
                        <CustomDropDown setshowDrop={setShowDrop} setHeaderVal={setheaderValue}>
                            <div className={classes.CustomDropDown}>
                                <div className={classes.Row}><p>User  Service  Distributer</p><p>Dealer</p></div>
                                <div className={classes.Row}><p>Wholesalers / Importers</p><p>Distributer</p></div>
                            </div>
                        </CustomDropDown>
                        :
                        <div className={classes.Row} onClick={(event) => { headerclickHandler(event) }}>
                            <h5 className='help'>How We Help</h5>
                            <img className='help' src={downArrowWhite} alt=''/>
                        </div>

                }
                {
                    showDrop && headerValue === 'knowUS' ?
                        <CustomDropDown setshowDrop={setShowDrop} setHeaderVal={setheaderValue}>
                            <div className={classes.CustomDropDown}>
                                <div className={classes.Row}><p>About</p><p>Policies</p></div>
                                <div className={classes.Row}><p>Careers</p><p>Press</p></div>
                            </div>
                        </CustomDropDown>
                        :
                        <div className={classes.Row} onClick={(event) => { headerclickHandler(event) }}>
                            <h5 className='knowUS'>Get to Know Us</h5>
                            <img className='knowUS' src={downArrowWhite} alt=''/>
                        </div>

                }
                {
                    showDrop && headerValue === 'Join' ?
                        <CustomDropDown setshowDrop={setShowDrop} setHeaderVal={setheaderValue}>
                            <div className={classes.CustomDropDown}>
                                <div className={classes.Row}><p>Upcoming Events</p></div>
                                <div className={classes.Row}><p>Become a Buyer</p></div>
                                <div className={classes.Row}><p>Become a Dealer</p></div>
                                {/* <div className={classes.Row}><p>Careers</p><p>Press</p></div> */}
                            </div>
                        </CustomDropDown>
                        :
                        <div className={classes.Row} onClick={(event) => { headerclickHandler(event) }}>
                            <h5 className='Join'>Join the Community</h5>
                            <img className='Join' src={downArrowWhite} alt=''/>
                        </div>

                }
                {
                    showDrop && headerValue === classes.NoBorder ?
                        <CustomDropDown setshowDrop={setShowDrop} setHeaderVal={setheaderValue}>
                            <div className={`${classes.CustomDropDown}${classes.NoBorder}`}>
                                <div className={classes.Row}><p className={classes.FollowUsWdiht}><img src={Facebook} alt='' />Facebook</p><p className={`${classes.FollowUsWdiht}${classes.TextLeft}`}><img src={YouTube} alt='' />YouTube</p></div>
                                <div className={classes.Row}><p className={classes.FollowUsWdiht}><img src={Twiter} alt='' />Twitter</p><p className={`${classes.FollowUsWdiht}${classes.TextLeft}`}><img src={Instagarm} alt='' />Instagram</p></div>
                            </div>
                        </CustomDropDown>
                        :
                        <div className={classes.Row} onClick={(event) => { headerclickHandler(event) }}>
                            <h5 className={classes.NoBorder}>Follow Us</h5>
                            <img className={classes.NoBorder} src={downArrowWhite} alt=''/>
                        </div>

                }
            </div>
        </Fragment >
    )
};

export default Footer;
